const postEquipmentsStr = {
  toastr: 'Equipamento adicionado',
  toastr1: 'O equipamento foi adicionado com sucesso',
  toastrError: 'Equipamento já cadastrado',
  toastrError1: 'Insira este CNPJ ou Nome já foi cadastrado',
  toastrError2: 'Erro ao criar Equipamento',
  serialNumberError: 'Já existe um equipamento com este mesmo número de série para este site',
};

export default postEquipmentsStr;
